import PropTypes from 'prop-types';
import React from 'react';
import { EditableTableCell } from 'components/EditableTable';
import cx from 'classnames';
import { error as parseError } from '../../../utils';
import inputStyles from 'styles/input.scss';
import S from 'styles/table.scss';

const InputCell = ({ lineItem, attr, label, onChange, cellValue,
                     type, className, cellReadOnly }) => {
  const value = lineItem[attr];
  const error = lineItem.errors && lineItem.errors[attr] && parseError(attr, lineItem.errors);
  const cellVal = (value === null || cellValue === null) ? '' : cellValue || value;
  const cellProps = { label, onChange, error, value: cellVal, cellReadOnly };
  return (<EditableTableCell {...cellProps}>
    <input
      type={type}
      value={value === null ? '' : value}
      className={cx(inputStyles.inputElement, S.input, className)}
    />
  </EditableTableCell>);
};

InputCell.defaultProps = {
  cellValue: '',
  display: true,
  type: 'text',
  className: '',
  cellReadOnly: false,
};

InputCell.propTypes = {
  lineItem: PropTypes.object.isRequired,
  display: PropTypes.bool,
  attr: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cellValue: PropTypes.node,
  type: PropTypes.string,
  className: PropTypes.string,
  cellReadOnly: PropTypes.bool,
};

export default InputCell;



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/inputCell.jsx